import React from 'react';
import { Container, Grid, Button } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import AddIcon from '@mui/icons-material/Add';
import TextForm, { P_TextForm } from './TextForm';
import { Link } from 'react-router-dom';
import { LABEL_ADDSITEINFO, LABEL_TOEDITPAGE, SCREEN_NAMES } from './const';

export default function ScreenHome(props: {
	propsTextForm: P_TextForm;
	addSiteInfo: () => any;
}) {
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.up('md'));
	const rightStyle = matches ? undefined : { textAlign: 'right' };
	return (
		<Container maxWidth={'lg'}>
			<Grid container spacing={3}>
				<Grid item md={8} sm={12} zeroMinWidth width={'100%'}>
					<TextForm
						value={props.propsTextForm.value}
						onChange={props.propsTextForm.onChange}
					/>
					<Button
						variant='text'
						startIcon={<AddIcon />}
						size={'small'}
						onClick={props.addSiteInfo}
					>
						{LABEL_ADDSITEINFO}
					</Button>
				</Grid>
				<Grid item md={4} sm={12} zeroMinWidth width={'100%'} sx={rightStyle}>
					<Button
						variant='contained'
						endIcon={<NavigateNextIcon />}
						//sx={{ justifyContent: 'flex-start' }}
						component={Link}
						to={SCREEN_NAMES.edit}
					>
						{LABEL_TOEDITPAGE}
					</Button>
				</Grid>
			</Grid>
		</Container>
	);
}
